import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const Language = () => {
  const [langdropdown, setLangdropdown] = useState(false);
  const [selected, setSelected] = useState("en");
  const { i18n } = useTranslation();

  useEffect(() => {
    const savedLang = localStorage.getItem("lang");
    if (savedLang) {
      setSelected(savedLang);
      i18n.changeLanguage(savedLang);
    }
  }, [i18n]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setSelected(lng);
    localStorage.setItem("lang", lng);
    setLangdropdown(false);
  };

  const toggleDropdown = () => {
    setLangdropdown((prev) => !prev);
  };

  const getFlagCode = (lang) => {
    switch (lang) {
      case "bm":
        return "my";
      case "cn":
        return "cn";
      default:
        return "us";
    }
  };

  const getLanguageLabel = (lang) => {
    switch (lang) {
      case "en":
        return "ENG";
      case "bm":
        return "BM";
      case "cn":
        return "中文";
      default:
        return lang.toUpperCase();
    }
  };

  return (
    <li className="language-nav">
      <div className={`translate_wrapper ${langdropdown ? "active" : ""}`}>
        <div className="current_lang">
          <div className="lang" onClick={toggleDropdown}>
            <i className={`flag-icon flag-icon-${getFlagCode(selected)}`}></i>
            <span className="lang-txt">{selected.toUpperCase()}</span>
          </div>
        </div>

        <div className={`more_lang ${langdropdown ? "active" : ""}`}>
          <div className="lang" onClick={() => changeLanguage("en")}>
            <i className="flag-icon flag-icon-us"></i>
            <span className="lang-txt">{getLanguageLabel("en")}</span>
          </div>

          <div className="lang" onClick={() => changeLanguage("cn")}>
            <i className="flag-icon flag-icon-cn"></i>
            <span className="lang-txt">{getLanguageLabel("cn")}</span>
          </div>

          <div className="lang" onClick={() => changeLanguage("bm")}>
            <i className="flag-icon flag-icon-my"></i>
            <span className="lang-txt">{getLanguageLabel("bm")}</span>
          </div>
        </div>
      </div>
    </li>
  );
};

export default Language;